export const ConfirmSignUpHeader = () => <h1>We Emailed You</h1>;
